import React, { useState } from "react";
import './searchbar.css';
import '../Dashboard/Mainstyle.css';
import Modal from 'react-modal';
import axios from 'axios';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getApi, postApi } from "../../components/Admin Master/Area Control/Zonemaster/ServicesApi";

function Searchbar() {

    const [searchValue, setSearchValue] = useState('');
    const [pincodeData, setPincodeData] = useState([]);
    const [searchTrackingValue, setSearchTrackingValue] = useState('');
    const [trackingData, setTrackingData] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [showImage, setShowImage] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen1, setModalIsOpen1] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value.replace(/\D/g, '');
        const sanitizedValue = inputValue.slice(0, 6);
        setSearchValue(sanitizedValue);
        setError('');
        setPincodeData([]);
    };

    const fetchData = async (e) => {
        e.preventDefault();
        if (searchValue.length !== 6) {
            alert('Please enter a 6-digit PIN code.');
            return;
        }

        try {
             const response = await getApi(`/Master/PincodeFinder?pincode=${searchValue}`);
                    if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
                    setModalIsOpen(true);
                    setPincodeData(response.data);
                    setError('');
                } else {
                    setPincodeData([]);
                    setError('Invalid data format received.');
                }
            }
        catch (error) {
            setError('Failed to fetch data. Please check your internet connection.');
            setPincodeData([]);
        }
    };

    const statusToStep = {
        'Shipped': 1,
        'In Transit': 2,
        'Delivered': 3,
    };

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    const handleInputTrackingChange = (e) => {
        const inputValue = e.target.value.slice(0, 200);
        setSearchTrackingValue(inputValue);
        setError('');
        setTrackingData([]);
    };

    const fetchTrackingData = async (e) => {
        if (!searchTrackingValue) {
            alert('Please enter docket no.');
            return;
        }
        e.preventDefault();
        try {
            const res = await getApi(`/Master/getTrackingData?DocketNo=${searchTrackingValue}`);
            if (res.status === 1 && res.Data) {
                setModalIsOpen1(true);
                const updatedData = res.Data.map((item) => {
                    const imageId = item.DocketNo;
                    return {
                        ...item,
                        ImageLink: `https://jdcargo.co.in/PODImg/POD_Image/${imageId}.jpg`,
                    };
                });

                setTrackingData(updatedData);
                setError('');

                if (updatedData.length > 0) {
                    const status = updatedData[0].Status;
                    setCurrentStep(statusToStep[status] || 1);
                }
            } else {
                setTrackingData([]);
                setError('Docket Not Found');
            }
        } catch (error) {
            console.error('Error:', error);
            setError(
                error.response?.data?.message || 'Failed to fetch data. Please check your internet connection or try again later.'
            );
        }
    };


    return (
        <>
        <style>{
            `
            .container2 {
  padding: 10px;
}

/* 💻 Desktop: side by side */
.tables-wrapper {
  display: flex;
  gap: 15px;
  align-items: flex-start;
  width:100%;
}

/* each table */
.table-container2 {
  width:80%;
}
.table-container3 {
  width:30%;
}


/* 📱 Mobile: column layout */
@media (max-width: 768px) {
  .tables-wrapper {
    flex-direction: column;
  }

  .table-container3 {
    width: 100%;
  }
    .table-container2 {
    width: 100%;
  }
}
            `
            }</style>
             <div className="search-bar">
            <form action="#" className="search-section" method="POST">
                <div className="input-div">
                <input type="text"
                    name="query"
                    placeholder="Enter Tracking Number"
                    value={searchTrackingValue} onChange={handleInputTrackingChange} />
                    <i className="bi bi-search" onClick={(e) => fetchTrackingData(e)}></i>
                </div>
                <div className="input-div">
                <input type="text"
                    name="query"
                    placeholder="Enter 6-digit pincode"
                    value={searchValue} onChange={handleInputChange}/>
                 
                    <i className="bi bi-search" onClick={(e) => fetchData(e)}></i>
                </div>

            </form>

            <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                className="custom-modal-receiver" contentLabel="Modal"
                style={{
                    content: {
                        top: '50%',             // Center vertically
                        left: '50%',
                        whiteSpace: "nowrap"
                    },
                }}>
                <div className="custom-modal-content">
                    <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                        <header style={{ width: "95%", textAlign: "center" }}>Pin Code Finder</header>
                        <button className="ok-btn" style={{ width: "5%", height: "100%", backgroundColor: "red" }}
                            onClick={() => setModalIsOpen(false)}>
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>


                    <div className='container2'>
                        <div className="table-container">
                            <table className=" table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">Pincode</th>
                                        <th scope="col">Area_Name</th>
                                        <th scope="col">Destination_Name</th>
                                        <th scope="col">State_Name</th>
                                        <th scope="col">Service</th>
                                        <th scope="col">Post/Oda</th>
                                        <th scope="col">Vendor_Name</th>
                                        <th scope="col">Zone_Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pincodeData.map((pincode, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{pincode.Pincode}</td>
                                            <td>{pincode.Area_Name}</td>
                                            <td>{pincode.City_Name}</td>
                                            <td>{pincode.State_Name}</td>
                                            <td>{pincode.Serviceable}</td>
                                            <td>{pincode.ODA_OPA}</td>
                                            <td>{pincode.Vendor_Name}</td>
                                            <td>{pincode.Zone_Name}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal >
                <Modal
  overlayClassName="custom-overlay"
  isOpen={modalIsOpen1}
  className="custom-modal"
  contentLabel="Modal"
  style={{
    content: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '95%',
      overflowY: 'auto',     // ✅ enable vertical scroll
      overflowX: 'auto',   // optional (clean UI)
      padding: '10px',
      zIndex:"999999999",
    },
  }}
>
                <div className="custom-modal-content">
                    <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                        <header className="" style={{ width: "95%", textAlign: "center" }}>Tracking Details</header>
                        <button className="ok-btn " style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                            onClick={() => setModalIsOpen1(false)}>
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>

                    <div className="container2">

  {trackingData.length > 0 ? (
    trackingData.map((record, index) => (

      <div className="tables-wrapper" key={index}>

        {/* Table 1 */}
        <div className="table-container3">
          <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
            <tbody>
              <tr><td className="w-60">Waybill No</td><td>{record.DocketNo}</td></tr>
              <tr><td className="w-60">Book Date</td><td>{record.BookDate}</td></tr>
              <tr><td className="w-60">Origin City</td><td>{record.OriginCity}</td></tr>
              <tr><td className="w-60">Receiver Name</td><td>{record.Consignee_Name}</td></tr>
              <tr><td className="w-60">Destination</td><td>{record.DestinationCity}</td></tr>
              <tr><td className="w-60">Status</td><td>{record.Status}</td></tr>
              <tr><td className="w-60">Qty</td><td>{record.Qty}</td></tr>
              <tr><td className="w-60">EWaybill</td><td>{record.EWaybill}</td></tr>
              <tr><td className="w-60">Invoice No</td><td>{record.InvoiceNo}</td></tr>
            </tbody>
          </table>
        </div>

        {/* Table 2 */}
        <div className="table-container2">
          <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
            <thead className="background">
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Location</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {record.StatusEntry && record.StatusEntry.length > 0 ? (
                record.StatusEntry.map((entry, idx) => (
                  <tr key={idx}>
                    <td>{entry.DelvDt}</td>
                    <td>{entry.DelvTime}</td>
                    <td>{entry.Destination_name}</td>
                    <td>{entry.Status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>No scans available.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>

    ))
  ) : (
    <div>No shipment details available.</div>
  )}

</div>
                    </div>
            </Modal >

        </div >
        </>
       
    )
}

export default Searchbar;